// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum PaperOrientation {
	Landscape = 1,
	Portrait = 2,
}
